import apiClient from '../api/apiClient'
import { BookersWithTargetsResponse, SetTargetForm, BulkSetTargetsForm, ApiResponse, MonthlyPerformanceResponse } from '../../types'

export const targetService = {
  // Get all bookers with their current month targets
  getBookersWithTargets: async (): Promise<BookersWithTargetsResponse> => {
    const response = await apiClient.get<BookersWithTargetsResponse>('/admin/targets/bookers')
    return response.data
  },

  // Get monthly performance with daily breakdown
  getMonthlyPerformance: async (month?: number, year?: number): Promise<MonthlyPerformanceResponse> => {
    const params = new URLSearchParams()
    if (month) params.append('month', month.toString())
    if (year) params.append('year', year.toString())
    
    const queryString = params.toString()
    const url = `/admin/targets/monthly-performance${queryString ? `?${queryString}` : ''}`
    
    const response = await apiClient.get<MonthlyPerformanceResponse>(url)
    return response.data
  },

  // Set or update target for a single booker
  setBookerTarget: async (data: SetTargetForm): Promise<ApiResponse<any>> => {
    const response = await apiClient.post<ApiResponse<any>>('/admin/targets/set', data)
    return response.data
  },

  // Bulk update targets for multiple bookers
  bulkSetTargets: async (data: BulkSetTargetsForm): Promise<ApiResponse<any>> => {
    const response = await apiClient.post<ApiResponse<any>>('/admin/targets/bulk', data)
    return response.data
  },
}


